import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes, AppTrustCenterPageRouteSegments } from '@anecdotes/configuration-data-access';

export const redirectGuard = async (): Promise<boolean> => {
  const router = inject(Router);

  router.navigate([AppRoutes.TrustCenter, AppTrustCenterPageRouteSegments.ActivityDashboard]);

  return true;
};
